// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"669587fff57ac07b0ae4","532":"d097e0842e8bc7271f1a","678":"fc1ad3ca878c484fbaf1","883":"e10e83ce49a406362719"}[chunkId] + ".js";
};